const customSelectors = {
  megaMenuLink: document.querySelectorAll('[data-link-handle'),
  megmenuImage: document.querySelectorAll('[data-mega-image]'),
  defaultMegaMenuImage: document.querySelector('.default-megamenu-image'),
  megamenuElement: document.querySelector('.megamenu a')
};
class customJS {
    constructor() {
        this.footerMenuCollapse();
        // this.collectionCollapse();
        this.equalHeight();

        // if(window.globalVariables.templateSuffix != 'club-member'){
        //   this.changeClubURL();
        // }
        // if(window.globalVariables.templateSuffix == 'club-member' || window.globalVariables.template == 'account'){
        //   this.clubmemberChanges();
        // }else{
        //   document.cookie = 'loginCookie=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
        //   if(window.globalVariables.template != 'index'){
        //     this.cookieOnload();
        //     this.sessionforRecharge();
        //   }
        // }
        this.MegamenuImageUpdate();

      let loginUrl = window.location.href;
      if(loginUrl.indexOf('/login') > 0){
        let username = loginUrl;
        Utility.setCookie('loginCookie', username, 1);
      }

    }
    MegamenuImageUpdate(){
      for(let i=0;i<=customSelectors.megaMenuLink.length;i++){
        if(customSelectors.megaMenuLink[i] != undefined){
          customSelectors.megaMenuLink[i].addEventListener('mouseover', (event) => {
            let menuHandle = event.target.getAttribute('data-link-handle');
            for(let j=0;j<=customSelectors.megmenuImage.length;j++){
              if(customSelectors.megmenuImage[j] != undefined){
                let imageHandle = customSelectors.megmenuImage[j].getAttribute('data-mega-image');
                if(imageHandle == menuHandle){
                  customSelectors.megmenuImage[j].classList.remove('d-none');
                  customSelectors.defaultMegaMenuImage.classList.add('d-none');
                } else {
                  customSelectors.megmenuImage[j].classList.add('d-none');
                }
              }

            }
          });
        }

      }

      // customSelectors.megamenuElement.addEventListener('mouseover', (event) => {
      //   customSelectors.defaultMegaMenuImage.classList.remove('d-none');
      //   for(let k=0;k<=customSelectors.megmenuImage.length;k++){
      //     customSelectors.megmenuImage[k].classList.add('d-none');
      //   }
      // });



     }
    footerMenuCollapse(){
        let readMoreElement = document.querySelectorAll('[data-read-more]');
        for(let i=0; i<readMoreElement.length; i++){
            readMoreElement[i].addEventListener('click', function(){
                let menuItem =  readMoreElement[i].closest('.footer-block--menu');
                let readMoreItem = menuItem.querySelector('.read-more-item');

                let liHeightAll = readMoreItem.querySelectorAll('ul li');
                let totalHeight = 0;
                for(let j=0; j<liHeightAll.length; j++){
                    let liHeight = liHeightAll[j].offsetHeight;
                    totalHeight += liHeight;
                }

                readMoreItem.style.height = totalHeight+'px';
                let readLess = menuItem.querySelector('.read-less');
                let readMore = menuItem.querySelector('.read-more');
                readMore.classList.add('d-none');
                readMore.classList.remove('d-block');
                readMoreItem.classList.add('open');
                readLess.classList.add('d-block');
                readLess.classList.remove('d-none');
            });
        }
        let readLessElement = document.querySelectorAll('[data-read-less]');
        for(let i=0; i<readLessElement.length; i++){
            readLessElement[i].addEventListener('click', function(){
                let menuItem =  readLessElement[i].closest('.footer-block--menu');
                let readMoreItem = menuItem.querySelector('.read-more-item');
                let readMore = menuItem.querySelector('.read-more');
                let readLess = menuItem.querySelector('.read-less');
                readMoreItem.classList.remove('open');
                readMoreItem.style.height = '0px';
                readMore.classList.add('d-block');
                readMore.classList.remove('d-none');
                readLess.classList.add('d-none');
                readLess.classList.remove('d-block');
            });
        }

    }

    // collectionCollapse(){
    //     let readMoreElement = document.querySelectorAll('[data-read-more-coll]');
    //     for(let i=0; i<readMoreElement.length; i++){
    //         readMoreElement[i].addEventListener('click', function(){
    //             let menuItem =  readMoreElement[i].closest('.collection-hero__text-wrapper');
    //             let readMoreItem = menuItem.querySelector('.read-more-content');
    //             let shortContent = menuItem.querySelector('.short-content');

    //             let readLess = menuItem.querySelector('.read-less');
    //             let readMore = menuItem.querySelector('.read-more');
    //             shortContent.classList.add('d-none');
    //             shortContent.classList.remove('d-block');
    //             readMore.classList.add('d-none');
    //             readMore.classList.remove('d-block');
    //             readMoreItem.classList.add('open');
    //             readLess.classList.add('d-block');
    //             readLess.classList.remove('d-none');
    //         });
    //     }
    //     let readLessElement = document.querySelectorAll('[data-read-less-coll]');
    //     for(let i=0; i<readLessElement.length; i++){
    //         readLessElement[i].addEventListener('click', function(){
    //             let menuItem =  readLessElement[i].closest('.collection-hero__text-wrapper');
    //             let readMoreItem = menuItem.querySelector('.read-more-content');
    //             let shortContent = menuItem.querySelector('.short-content');
    //             let readMore = menuItem.querySelector('.read-more');
    //             let readLess = menuItem.querySelector('.read-less');
    //             shortContent.classList.add('d-block');
    //             shortContent.classList.remove('d-none');
    //             readMoreItem.classList.remove('open');
    //             readMore.classList.add('d-block');
    //             readMore.classList.remove('d-none');
    //             readLess.classList.add('d-none');
    //             readLess.classList.remove('d-block');
    //         });
    //     }

    // }
  
    equalHeight(){
        var elements = document.querySelectorAll(".equalHeight"),
        allHeights = [],
        i = 0;
        for(i = 0; i < elements.length; i++){
            var elementHeight = elements[i].offsetHeight;
            allHeights.push(elementHeight);
        }
        for(i = 0; i < elements.length; i++){
            elements[i].style.height = Math.max.apply( Math, allHeights) + 'px';
            elements[i].className = elements[i].className + " show";
        }

        
       
    }
    clubmemberChanges() {
      let referrer = document.referrer;
      let clubMemberReferrer = window.location.href;

      if(window.globalVariables.checkActivesubscriber){
        let accountPage = document.querySelector(".template-account");
        if (accountPage) {
          let login_Page = Utility.getCookie('loginCookie');
          document.cookie = 'loginCookie=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
          if (login_Page?.indexOf('/login') > 0) {
            window.location.href = "/pages/club-member";
          }else if (referrer.indexOf('/challenge') > 0) {
            window.location.href = "/pages/club-member";
          }else {
            accountPage.classList.remove("d-none");
          }
        }
      }else{
        document.cookie = 'loginCookie=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
        if (clubMemberReferrer.indexOf('/pages/club-member') > 0) {
          //window.location.href = "/";
        }
        let accountPage = document.querySelector(".template-account");
        if (accountPage) {
          accountPage.classList.remove("d-none");
        }
      }
    }
    cookieOnload() {
      const subscriptionFlow = document.querySelectorAll("#clubFlowOK, .join-badass-btn").forEach( btn => {
        btn.addEventListener("click",(e) => {
          let username = 'clubmemberNotFound';
          Utility.setCookie('redirect_page', username, 1);
        });
      });
      document.addEventListener('click', function(e){
        if(e.target && e.target.id == 'subscribeBtn'){
          let username = 'clubmemberNotFound';
          Utility.setCookie('redirect_page', username, 1);
        }
      });
    }
    sessionforRecharge() {

        if(document.querySelector("#recharge-novum")){
        let oneTimeProd = document.querySelector(".oneTime_product_collection").getAttribute("data-collection_product_handle");
        let swapProd = document.querySelector(".swap_product_collection").getAttribute("data-collection_product_handle");

        async function getProductData(url,storageName) {
          let requestURL = url;
          const response = await fetch(requestURL);
          const data = await response.json();
          if (data) {
              let responseData = data;
              let mappedProducts = responseData.products;
              if (!Array.isArray(responseData.products)) {
                mappedProducts = [responseData.products];
              }
              Utility.setSessionStorage(storageName, JSON.stringify(mappedProducts));
          }

        }

        getProductData(`/collections/${oneTimeProd}?view=products.json`,"rc_customize_onetime_products");
        getProductData(`/collections/${swapProd}?view=productsswap.json`,"rc_customize_swap_products");

      }

    }
    changeClubURL(){
      // Get Subscription List and show List of subscription
      if(window.globalVariables.customerEmail){

        let apiHeader = {
          Accept: 'application/json, text/javascript, /; q=0.01',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Content-Type': 'application/json',
          'Cache-Control': 'must-revalidate',
          'Cache-Control': 'no-cache',
          'Cache-Control': 'no-store',
          'X-Shop': 'badassbeardcare.myshopify.com',
          Pragma: 'no-cache',
          crossDomain: true
        };
        let API = 'https://api-manager.praella.app/api/recharge/common';

        var config1 = {
          'url': `/customers?email=${window.globalVariables.customerEmail}`,
          'method': 'GET'
        };


        fetch(API, {
          method: 'POST',
          headers: apiHeader,
          body: JSON.stringify(config1)
        }).then(response => response.json())
        .then(response => {

          if (response.customers[0]) {
            document.querySelector("#rc_link_container").closest("li.navBar-item").classList.remove("d-none");

            let config = {
              'url': `/subscriptions?shopify_customer_id=${window.globalVariables.customerID}`,
              'method': 'GET'
            };

            fetch(API, {
              method: 'POST',
              headers: apiHeader,
              body: JSON.stringify(config)
            }).then(response => response.json())
            .then(getdata => {

              if (getdata.subscriptions) {
                let clubPageFlag = false;

                if (getdata.subscriptions.length > 0){
                  let subscriptionsData = getdata.subscriptions;
                  subscriptionsData.forEach(subscription => {
                      if (subscription.status == 'ACTIVE') {
                        clubPageFlag = true;
                        return false;
                      }
                  });
                }

                if (clubPageFlag) {
                  document.querySelectorAll(".nav-link.account_link").forEach(el => {
                      el.setAttribute('href', '/pages/club-member');
                  });
                  document.querySelector(".clubPageLink a").setAttribute('href','/pages/club-member');
                  document.querySelector(".clubPageLink a").removeAttribute('data-modal-opener');
                } else {
                  document.querySelectorAll(".nav-link.account_link").forEach(el => {
                      el.setAttribute('href', '/account');
                  });

                  document.querySelector(".clubPageLink a").setAttribute('href','#');
                  document.querySelector(".clubPageLink a").setAttribute('data-modal-opener','Popup-infoModal');
                  document.querySelector(".clubPageLink a").addEventListener('click', function(e) {
                    e.preventDefault();
                    var dialogInstance = document.querySelector('#Popup-infoModal');
                    dialogInstance.show();
                  })
                }


              }

            });


          }
        });



      }


    }
}

typeof customJS !== 'undefined' && new customJS();

$(document).ready(function(){
  $(".menu-drawer-close").click(function(){
    $('.header__icon--menu').click();
  });
});


const selectors = {
  stickyAddBtn: document.querySelector('[data-stciky-add-cta]')
};
class templateProductJS {
  constructor() {

    if (selectors.stickyAddBtn) {

      selectors.stickyAddBtn.addEventListener('click', () => {
        document.querySelector('[data-addtocart-btn]').click();
      });
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const intersecting = entry.isIntersecting;
          let stickyElement = document.querySelector('.sticky-add-btn ');
          intersecting ? stickyElement.classList.remove('visible') : stickyElement.classList.add('visible')
        });
      })

      observer.observe(document.querySelector("[data-add-cta-wrapper]"));
    }

  }
}

typeof templateProductJS !== 'undefined' && new templateProductJS();


// EXPAND/COLLAPSE COLLECTION DESCRIPTION
document.addEventListener("DOMContentLoaded", function () {
  const readMoreButton = document.querySelector(".collection-hero [data-read-more-coll]");
  const readLessButton = document.querySelector(".collection-hero [data-read-less-coll]");
  const shortContent = document.querySelector(".collection-hero .short-content");
  const fullContent = document.querySelector(".collection-hero .read-more-content");

  // Show full content and toggle buttons on "Read More" click
  readMoreButton.addEventListener("click", function () {
    shortContent.style.display = "none"; // Hide truncated content
    fullContent.style.display = "block"; // Show full content
    readMoreButton.classList.add("d-none"); // Hide 'Read More' button
    readLessButton.classList.remove("d-none"); // Show 'Read Less' button
  });

  // Show truncated content and toggle buttons on "Read Less" click
  readLessButton.addEventListener("click", function () {
    shortContent.style.display = "block"; // Show truncated content
    fullContent.style.display = "none"; // Hide full content
    readMoreButton.classList.remove("d-none"); // Show 'Read More' button
    readLessButton.classList.add("d-none"); // Hide 'Read Less' button
  });
});

